import React from 'react';

export default () => (
  <div className="premium">
    <div>
      <h1 className="premium__title">Become a patron</h1>
      <p className="premium__subtitle">
        50% of all proceeds go to help support Raleigh's local theatre and arts
        community.
      </p>
    </div>

    <div>
      <h3 className="premium__membership--title">
        Whats included in a premium membership?
      </h3>

      <p className="premium__membership--benefit">
        Access to all premium content from Charles Keith, including serial
        pieces, reviews and more.
      </p>
      <p className="premium__membership--benefit">
        Updates on must see events in the Triangle.
      </p>
      <p className="premium__membership--benefit">
        A great, no hassle way to support your local arts scene.
      </p>
    </div>

    <div>
      <p className="content__btn content__btn--blue"> Let's Upgrade </p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/HomePage/PremiumPitch.js